import trackProductEvent from '../../utils/trackProductEvent';

export const trackOutfitContextItemClick = (state, clickedSkuId) => {
  if (state.skipEventTracking) {
    return;
  }

  const eventName = 'gated_outfit_context_item_click';
  const canonicalName = 'pdp';
  const actionType = 'click';
  const actionName = 'outfit_context_nav_thumbnail_click';
  const actionDetail = 'gated_shop';
  const directBuyContext = {
    outfit_id: state.outfitId,
    clicked_sku_id: clickedSkuId,
    sku_id: state.selectedSkuId,
    sub_source: state.subSource,
    source: state.source,
  };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
  });
};

export const trackOutfitContextCarouselView = state => {
  if (state.skipEventTracking) {
    return;
  }

  const eventName = 'gated_outfit_context_carousel_view';
  const canonicalName = 'pdp';
  const actionType = 'view';
  const actionName = 'outfit_context_nav_view';
  const actionDetail = 'gated_shop';
  const directBuyContext = {
    outfit_id: state.outfitId,
    sku_id: state.selectedSkuId,
    sub_source: state.subSource,
    source: state.source,
  };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
  });
};
